// extracted by mini-css-extract-plugin
export var blueGhost = "gRzI5y6kxQeOAFzJa3wI ftlsSSF3qaNwnCOcjCLn";
export var blueUnderlined = "ftlsSSF3qaNwnCOcjCLn";
export var colourInherit = "LHQDegVLgEn5aYlr_ppS";
export var focusVisible = "dyI5XIiMYfO1yNGBM0sW";
export var icon = "ASWhveKHGLiJAd9IRVJr";
export var root = "ZlDE4cxSd0gvmXph4a4L";